import CityPageTemplate from "../city-template/CityPageTemplate";
import { greensboroConfig } from "./data";

export default function GreensboroPage() {
  return <CityPageTemplate config={greensboroConfig} />;
}